export const expenceReportData = [
  {
    key: "1",
    INVOICENO: "#INV12345",
    CATEGORY: "Vehicle Repairs",
    VEHICLERELATED: "$3,800",
    OPERATIONAL: "$200",
    MISCELLANEOUS: "$200",
    TOTALEXPENSE: "$5,100",
    DATE: "24 Jan 2025",
    STATUS: "Paid",
  },
  {
    key: "2",
    INVOICENO: "#INV12346",
    CATEGORY: "Vehicle Repairs",
    VEHICLERELATED: "$1,500",
    OPERATIONAL: "$300",
    MISCELLANEOUS: "0",
    TOTALEXPENSE: "$1,800",
    DATE: "19 Dec 2024",
    STATUS: "Pending",
  },
  {
    key: "3",
    INVOICENO: "#INV12347",
    CATEGORY: "Staff Salaries",
    VEHICLERELATED: "0",
    OPERATIONAL: "$5,000",
    MISCELLANEOUS: "0",
    TOTALEXPENSE: "$5,000",
    DATE: "11 Dec 2024",
    STATUS: "Paid",
  },
  {
    key: "4",
    INVOICENO: "#INV12348",
    CATEGORY: "Office Rent",
    VEHICLERELATED: "$0",
    OPERATIONAL: "$3,000",
    MISCELLANEOUS: "$0",
    TOTALEXPENSE: "$3,000",
    DATE: "29 Nov 2024",
    STATUS: "Overdue",
  },
  {
    key: "5",
    INVOICENO: "#INV12349",
    CATEGORY: "Marketing",
    VEHICLERELATED: "$0",
    OPERATIONAL: "$0",
    MISCELLANEOUS: "$1,200",
    TOTALEXPENSE: "$1,200",
    DATE: "03 Nov 2024",
    STATUS: "Paid",
  },
  {
    key: "6",
    INVOICENO: "#INV12350",
    CATEGORY: "Insurance",
    VEHICLERELATED: "$1,800",
    OPERATIONAL: "$500",
    MISCELLANEOUS: "$0",
    TOTALEXPENSE: "$2,300",
    DATE: "31 Oct 2024",
    STATUS: "Pending",
  },
  {
    key: "7",
    INVOICENO: "#INV12351",
    CATEGORY: "Website Hosting",
    VEHICLERELATED: "$0",
    OPERATIONAL: "$0",
    MISCELLANEOUS: "$600",
    TOTALEXPENSE: "$600",
    DATE: "15 Oct 2024",
    STATUS: "Paid",
  },
  {
    key: "8",
    INVOICENO: "#INV12352",
    CATEGORY: "Cleaning Supplies",
    VEHICLERELATED: "$500",
    OPERATIONAL: "$200",
    MISCELLANEOUS: "$0",
    TOTALEXPENSE: "$700",
    DATE: "26 Sep 2024",
    STATUS: "Failed",
  },
  {
    key: "9",
    INVOICENO: "#INV12353",
    CATEGORY: "Car Loan Payment",
    VEHICLERELATED: "$4,500",
    OPERATIONAL: "$0",
    MISCELLANEOUS: "$0",
    TOTALEXPENSE: "$4,500",
    DATE: "01 Sep 2024",
    STATUS: "Paid",
  },
  {
    key: "10",
    INVOICENO: "#INV12354",
    CATEGORY: "Software Subscription",
    VEHICLERELATED: "$0",
    OPERATIONAL: "$0",
    MISCELLANEOUS: "$900",
    TOTALEXPENSE: "$900",
    DATE: "15 Aug 2024",
    STATUS: "Paid",
  },
];
